import React from 'react';
import { Modal, Icon } from '@common/components';
import { Col, Row, Typography } from 'antd';
import { Colors } from '@common/tokens';

const { Title, Text } = Typography;

export function IncentivesUpdateStepsErrorModal({
  onSave,
  visible,
}: {
  onSave: () => void;
  visible: boolean;
}) {
  return (
    <>
      <Modal
        className="update-steps-error-modal"
        onOk={onSave}
        okText="Try Again"
        cancelText="Back"
        visible={visible}
      >
        <Row>
          <Col span={2}>
            <Icon icon="circleXmark" kind="solid" color="coral" size="xl" />
          </Col>
          <Col span={20}>
            <div className="update-steps-error-modal__message">
              <Title level={3}>Failed to update</Title>
              <Text>Rates did not get updated.</Text>
            </div>
          </Col>
        </Row>
      </Modal>
      <style jsx>{`
        :global(.update-steps-error-modal.ant-modal .ant-modal-footer) {
          display: flex;
          justify-content: flex-end;
        }
        :global(
          .update-steps-error-modal.ant-modal
            .ant-modal-footer
            .ant-btn:first-child
        ) {
          order: 1;
          margin-left: 8px;
        }
        :global(.update-steps-error-modal__message h3.ant-typography) {
          font-size: 20px;
          line-height: 24px;
          margin-bottom: 16px;
        }
        :global(.update-steps-error-modal__message span.ant-typography) {
          font-size: 16px;
          line-height: 20px;
          color: ${Colors.midnightLighter};
        }
      `}</style>
    </>
  );
}
